interface EventParams {
  [key: string]: string | number | boolean | undefined;
}

type GtagFn = (
  command: "event",
  eventName: string,
  params?: EventParams
) => void;

declare global {
  interface Window {
    gtag?: GtagFn;
    __diaperHumanBound?: boolean;
  }
}

function isAnalyticsEnabled() {
  if (typeof window === "undefined") {
    return false;
  }
  const host = window.location.hostname;
  return host === "diapercompare.com" || host === "www.diapercompare.com";
}

export function trackEvent(name: string, params?: EventParams) {
  if (!isAnalyticsEnabled() || typeof window.gtag !== "function") {
    return;
  }
  window.gtag("event", name, params);
}

export function trackAffiliateClick({
  asin,
  brand,
  title,
  price,
  unitPrice,
  hasAffiliateTag,
}: {
  asin: string;
  brand?: string;
  title?: string;
  price?: number;
  unitPrice?: string;
  hasAffiliateTag: boolean;
}) {
  trackEvent("affiliate_click", {
    item_id: asin,
    item_brand: brand || "(not set)",
    item_name: title || asin,
    value: price || 0,
    unit_price: unitPrice || "",
    has_affiliate_tag: hasAffiliateTag,
  });
}

export function trackFilterChange({
  filterType,
  selectedValues,
  resultCount,
}: {
  filterType: string;
  selectedValues: string[];
  resultCount: number;
}) {
  trackEvent("filter_change", {
    filter_type: filterType,
    filter_values: selectedValues.join(",") || "(cleared)",
    result_count: resultCount,
  });
}

export function trackBlogSearch(term: string, resultCount: number) {
  const trimmed = term.trim();
  if (!trimmed) {
    return;
  }
  trackEvent("blog_search", {
    search_term: trimmed,
    result_count: resultCount,
  });
}

export function bindHumanSignal() {
  if (typeof window === "undefined" || window.__diaperHumanBound) {
    return;
  }
  window.__diaperHumanBound = true;

  function sendHumanSignal() {
    trackEvent("human_signal", {
      path: window.location.pathname,
    });
    window.removeEventListener("pointerdown", sendHumanSignal);
    window.removeEventListener("keydown", sendHumanSignal);
    window.removeEventListener("touchstart", sendHumanSignal);
  }

  window.addEventListener("pointerdown", sendHumanSignal, { once: true });
  window.addEventListener("keydown", sendHumanSignal, { once: true });
  window.addEventListener("touchstart", sendHumanSignal, { once: true });
}
